import { render, staticRenderFns } from "./SolutionsA.vue?vue&type=template&id=64499ff0"
import script from "./SolutionsA.vue?vue&type=script&lang=js"
export * from "./SolutionsA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports